export const sleep = async (time: number) => {
    await new Promise((resolve, reject) => {
        try {
            setTimeout(resolve, time);
        } catch (error: unknown) {
            reject(error);
        }
    });
};
